export default "__VITE_ASSET__QpvozmUc__"